import React, { useEffect,useState } from "react";
// import { connect } from "react-redux";
import SocialOptions from "./SocialOptions";
import SignUp from "./SignUp";
import { useSelector, useDispatch } from "react-redux";
import { v4 as uuid } from "uuid";
import ReactGA from "react-ga4";

import Login from "./Login";
import "./SocialOptions.css";

// Antd CSS
import "antd/dist/antd.css";
import { checkEmailFlow, signUpLoginUpdate, userClicked } from "../../../redux/actions";
import { APP_NAME, EVENTS, PAGE, PAGE_TYPE } from "../../../constants/userTrackingConstants";

// import Amplify, { Auth, Hub } from "aws-amplify";

function SignUpLogin() {
  const dispatch = useDispatch();

  const emailForward = useSelector((state) => state.authReducer.emailCheck);
  const signUpLogin = useSelector((state) => state.authReducer.signUpLogin);
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  useEffect(() => {
 

    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  const switchToLoginSignUp = () => {
    ReactGA.event({
      category: "User Interaction",
      action:
        APP_NAME.EMPLOYER +
        " " +
        (signUpLogin ? EVENTS.SIGN_IN_TEXT_CLICK : EVENTS.SIGN_UP_TEXT_CLICK),
      label: "Signup Button",
    });

    dispatch(
      userClicked({
      uuid: uuid,
      event: signUpLogin ? EVENTS.SIGN_IN_TEXT_CLICK : EVENTS.SIGN_UP_TEXT_CLICK,
      pageType: signUpLogin ? PAGE_TYPE.SIGNUP : PAGE_TYPE.SIGNIN,
      page: PAGE.MODAL,
      appName: APP_NAME.EMPLOYER,
      url: window?.location?.pathname,
    }))
    dispatch(checkEmailFlow(false));
    dispatch(signUpLoginUpdate(!signUpLogin));
  };

  return (
    <div className="authorizationSkill">
      <h1 className="topHeading">
        {signUpLogin ? "Join SkillGigs" : "Sign in to SkillGigs"}
      </h1>
      {
      // !emailForward && (
        <>
          <div>
            {/* <h1 className="topHeading">Join SkillGigs</h1> */}
            <SocialOptions signUpLogin={signUpLogin} />
            <div className="dividerWidth">
              <h5 className="divider">OR</h5>
            </div>
          </div>
        </>
      // )
      }
      {signUpLogin ? (
        <>
          <SignUp />
        </>
      ) : (
        <Login />
      )}
  {windowDimensions?.width > 700 ?<div className="authDivider"></div>:""}
      <div className="accountAlready">
        {signUpLogin ? (
          <>
            Already have an account?
            <span className="accountSignIn" onClick={switchToLoginSignUp}>
              {` Sign in`}
            </span>
          </>
        ) : (
          <>
            Not a member yet?
            <span className="accountSignIn" onClick={switchToLoginSignUp}>
              {` Join now`}
            </span>
          </>
        )}
      </div>
    </div>
  );
}

export default SignUpLogin;

// const mapStateToProps = (state) => ({});

// const mapDispatchToProps = {};

// export default connect(mapStateToProps, mapDispatchToProps)(SocialLogin);
